<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="1520px"
            height="100%"
            no-click-animation
            >
            <div :class="{ 'd-none': loading }" >
                <v-card class="cardWrap">
                    <CardTitle :title="page_title" />
                    <v-form ref="form">
                        <v-container class="mx-2">
                            <v-row no-gutters>
                                <v-col cols="4" :class="labelObj">{{ golfCourseName }}</v-col>
                                <v-col cols="2">
                                    <v-select
                                        class="mr-3"
                                        :items="yearInSelectBox"
                                        item-value="year"
                                        item-text="year"
                                        v-model="search.year"
                                        label="年"
                                    />
                                </v-col>
                                <v-col cols="2">
                                    <v-select
                                        :items="monthInSelectBox"
                                        v-model="search.month"
                                        label="月"
                                    />
                                </v-col>
                                <v-col cols="2">
                                    <v-btn
                                        :disabled="btn[1].isActive"
                                        color="primary"
                                        class="ml-5 mt-4"
                                        @click="clickSearch"
                                    >検索</v-btn>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <div>{{ propsPlanName }}</div>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="4">
                                    <v-radio-group
                                        v-model="search.day"
                                        row
                                        :rules="[rules.required]"
                                    >
                                        <v-radio
                                            v-for="d in dayInSelectBox"
                                            :key="d.id"
                                            :label="d.code_name"
                                            :value="d.code"
                                        />
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field
                                        maxlength="2"
                                        placeholder="01"
                                        v-model="input.playDateFrom"
                                        inputmode="tel"
                                        :prefix="dateFromPre"
                                        :disabled="search.day !== 4"
                                        :rules="[
                                            rules.format_date,
                                            rules.correctDateBetween
                                        ]"
                                    >
                                        <template v-slot:append-outer>
                                            <span class="mt-2">~</span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field
                                        maxlength="2"
                                        placeholder="01"
                                        v-model="input.playDateTo"
                                        inputmode="tel"
                                        :prefix="dateToPre"
                                        :disabled="search.day !== 4"
                                        :rules="[
                                            rules.format_date,
                                            rules.correctDateBetween
                                        ]"
                                    />
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-select
                                    class="pa-2"
                                    :items="coursesList"
                                    item-value="course_code"
                                    item-text="course_name"
                                    v-model="input.courseValue"
                                    label="コースを選択"
                                    hide-details
                                    width="100px"
                                    :rules="[rules.required]"
                                />
                                <v-select
                                    class="pa-2"
                                    :items="feeList"
                                    item-value="fee_id"
                                    item-text="textFee"
                                    v-model="input.feeValue"
                                    label="料金を選択"
                                    hide-details
                                    width="100px"
                                    :rules="[rules.required]"
                                />
                                <v-col cols="2">
                                    <v-btn
                                        class="px-3"
                                        color="primary"
                                        @click="isChangeCheckbox"
                                    >指定した条件でチェック</v-btn>
                                </v-col>
                                <v-col cols="2">
                                    <v-btn
                                        class="px-3"
                                        color="primary"
                                        @click="isCheckClear"
                                    >全てのチェックをクリア</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                    <v-data-table
                        :headers="headers"
                        :items="desserts"
                        hide-default-footer
                        class="elevation-1"
                    >
                        <template v-slot:item="{ item }">
                            <tr>
                                <td class="text-center">{{ item.displayTotalFee }}</td>
                                <td class="text-center">{{ item.course_name }}</td>
                                <template v-for="(cell, i) in item.days">
                                    <td :key="cell.key" class="text-center">
                                        <input
                                            type="checkbox"
                                            v-model="cell.value"
                                            v-if="cell.value !== null"
                                            @click="sendData = false"
                                            :disabled="isCheckedOnSomeDay(item, i)"
                                        >
                                    </td>
                                </template>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
                        <v-btn
                            color="green darken-4"
                            text
                            @click="displayAddOverLay"
                            :disabled="sendData || btn[2].isActive">登録</v-btn>
                    </v-card-actions>
                    <AddOverlay
                        page-name="連携枠一覧"
                        @processing="updateFeeIDsToPlanCells"
                        @cancel="closeAddOverLay"
                        :process-result="process"
                        :OverlaySwitch="addOverlay"
                    />
                </v-card>
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import validater from '../../../lib/validater';
import AddOverlay from '@/components/overlay/AddOverlay';
// mixins
import { authorityMixin } from '@/views/authorityMixin';
import { utilityMixin } from '../../../mixins/utility';
import { judgeDayMixin } from '../../../mixins/judgeDay';
// graghql
import { CODE_MASTER } from '@/views/config';
import { GET_LINK_YEARS } from '@/constants/reserve';
import {
    GET_PLAN_CELL,
    UPDATE_FEE_IDS_TO_PLAN_CELLS,
    GET_COURSE_LIST,
    GET_FEE_LIST } from '@/constants/plan';

export default {
    components: {
        CardTitle,
        AddOverlay
    },
    mixins: [
        authorityMixin,
        utilityMixin,
        judgeDayMixin
    ],
    props: [
        'dialog',
        'golfCourseProps',
        'propsPlanName',
        'golfSelectProps',
        'propsPlanId'
    ],
    data () {
        return {
            c: 1,
            addOverlay: false,
            golfGroupCode: process.env.VUE_APP_GROUP_CODE,
            // 年の選択ボックス
            yearInSelectBox: [],
            // 月の選択ボックス
            monthInSelectBox: [],
            // 日の選択ボックス
            dayInSelectBox: [
                { code: 1, code_name: '全日' },
                { code: 2, code_name: '平日' },
                { code: 3, code_name: '休日' },
                { code: 4, code_name: '期間指定' }
            ],
            // 検索値
            search: {
                year: '',
                month: ''
            },
            // 入力値
            input: {
                year: '',
                month: '',
                playDateFrom: '',
                playDateTo: '',
                courseValue: '',
                feeValue: ''
            },
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: '',
                // 処理中かどうか
                processing: false
            },
            // データテーブルに渡す値
            desserts: [],
            // 送信するデータ
            sendData: true,
            // データテーブルの見出し要素
            headers: [],
            dayOfWeek: [
                { id: Number(CODE_MASTER.SUNDAY['id']), name: CODE_MASTER.SUNDAY['name'] },
                { id: Number(CODE_MASTER.MONDAY['id']), name: CODE_MASTER.MONDAY['name'] },
                { id: Number(CODE_MASTER.TUESDAY['id']), name: CODE_MASTER.TUESDAY['name'] },
                { id: Number(CODE_MASTER.WEDNESDAY['id']), name: CODE_MASTER.WEDNESDAY['name'] },
                { id: Number(CODE_MASTER.THURSDAY['id']), name: CODE_MASTER.THURSDAY['name'] },
                { id: Number(CODE_MASTER.FRIDAY['id']), name: CODE_MASTER.FRIDAY['name'] },
                { id: Number(CODE_MASTER.SATURDAY['id']), name: CODE_MASTER.SATURDAY['name'] }
            ],
            // モーダルタイトル コンポーネントに渡す値：モーダルタイトル
            page_title: '料金連携',
            // ゴルフ場名
            golfCourseName: '',
            // コースセレクト
            coursesList: [],
            // 料金セレクト
            feeList: [],
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '検索', isActive: true },
                { element_id: '002', element_name: '更新', isActive: true }
            ],
            vue_id: 'SCR0033',
            loading: false,
            dateFromPre: '',
            dateToPre: '',
            targetDays: 0,
            labelObj: {
                'd-flex': true,
                'justify-start': true,
                'align-self-center': true,
                'py-2': true
            },
            rules: {
                // 必須項目
                required: value => !!value || this.$t('error.validation.required.any'),
                format_date: value => validater.checkStringType(value) || this.$t('error.validation.stringtype'),
                // 期間指定専用
                correctDateBetween: value => this.checkCorrectDate(value) || this.$t('error.validation.date.Correct')
            }
        };
    },
    async created () {
        this.initialize();
        let now = new Date();
        let years = await this.getLinkYears();
        this.yearInSelectBox.push(...years);
        let nowYear = now.getFullYear();
        let nowMonth = now.getMonth() + 1;
        for (let i = 1; i <= 12; i++) {
            this.monthInSelectBox.push(String(i));
        }
        this.admin = await this.getLoginAdmin();
        await this.getAuthorityList();
        this.$set(this.search, 'year', String(nowYear));
        this.$set(this.search, 'month', String(nowMonth));
    },
    computed: {
        isCheckedOnSomeDay () {
            return (item, date) => {
                const data = this.desserts.map(records => {
                    if (records.fee_id !== item.fee_id) {
                        return records['days'][date]['value'];
                    }
                });
                const filterdData = data.filter(v => v);
                return filterdData[0];
            };
        }
    },
    watch: {
        // 親からデータが渡ってきたときに発火
        async propsPlanId () {
            if (this.propsPlanId !== '') {
                this.makeHeaders();
                this.input.year = this.search.year;
                this.input.month = this.search.month;
                this.getCourse();
                await this.getFeeList();
            }
        },
        golfCourseProps () {
            const data = this.golfSelectProps.find(el => el.golf_code === this.golfCourseProps);
            this.golfCourseName = data.golf_name;
        },
        search: {
            handler (val) {
                this.dateFromPre = this.search.year + '-' + this.search.month.padStart(2, '0') + '-';
                this.dateToPre = this.search.year + '-' + this.search.month.padStart(2, '0') + '-';
            },
            deep: true
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         *---------------------------------------------- */
        initialize: async function () {
            this.input.courseValue = 0;
            this.input.feeValue = 0;
        },
        /** --------------------------------------------
        * ヘッダーを作成
        *-------------------------------------------- */
        makeHeaders () {
            const targetDays = new Date(this.search.year, this.search.month, 0).getDate();
            this.targetDays = targetDays;
            let dayList = [
                { text: '総額', aligh: 'center', sortable: false, value: 'total_fee', width: 100 },
                { text: 'コース', aligh: 'left', sortable: false, value: 'course_name', width: 110 }
            ];
            for (let i = 1; i <= targetDays; i++) {
                let targetDate = new Date(`${this.search.year}-${this.search.month}-${i}`);
                let targetDay = this.dayOfWeek[targetDate.getDay()]['name'];
                if (i < 10) {
                    dayList.push({
                        text: '0' + i + targetDay,
                        align: 'center',
                        sortable: false,
                        value: 'day' + i,
                        class: 'dayWidth' + this.judgeDay(targetDate)
                    });
                } else {
                    dayList.push({
                        text: i + targetDay,
                        align: 'center',
                        sortable: false,
                        value: 'day' + i,
                        class: 'dayWidth' + this.judgeDay(targetDate)
                    });
                }
            }
            this.headers = dayList;
        },
        /** --------------------------------------------
        * セル情報を取得
        * -------------------------------------------- */
        getCellInfo () {
            this.$apollo.mutate({
                mutation: GET_PLAN_CELL,
                variables: {
                    plan_id: this.propsPlanId,
                    date: this.search.year + '-' + this.search.month
                }
            }).then(res => {
                let records = res.data.getPlanCell;
                this.desserts.splice(0, this.desserts.length);
                let key = 0;
                records.forEach(record => {
                    var fee = Number(record.total_fee);
                    record.displayTotalFee = fee.toLocaleString();
                    Object.keys(record.days).forEach(function (day, index) {
                        if (day === '__typename') return delete record.days[day];
                        const feeId = record.fee_id;
                        const feeFlag = record.days[day];
                        const courseCode = record.course_code;
                        let currentDate = index + 1;
                        record.days[day] = {
                            'key': key,
                            'fee_id': feeId,
                            'value': feeFlag,
                            'day': currentDate,
                            'course_code': courseCode
                        };
                        key++;
                    });
                    this.desserts.push(record);
                });
            });
        },
        /** --------------------------------------------
        * チェックボタンの処理
        * -------------------------------------------- */
        isChangeCheckbox () {
            // 検索値
            const courseCode = this.input.courseValue;
            const feeId = this.input.feeValue;
            if (this.$refs.form.validate()) {
                this.desserts.forEach(record => {
                    Object.keys(record.days).forEach(day => {
                        const cell = record.days[day];
                        const current = new Date(`${this.search.year}-${this.search.month}-${cell.day}`);
                        const holiday = this.judgeDay(current);
                        const weekDay = String(current.getDay());
                        if (cell.value !== null) {
                            if (this.search.month > current.getMonth()) {
                                switch (this.search.day) {
                                // 全日指定の場合
                                case 1:
                                    if (record.course_code === courseCode && record.fee_id === feeId) {
                                        cell.value = true;
                                    } else if (record.course_code === courseCode && record.fee_id !== feeId) {
                                        cell.value = false;
                                    } else if (record.course_code !== courseCode && record.fee_id !== feeId) {
                                        cell.value = false;
                                    }
                                    break;
                                // 平日指定の場合
                                case 2:
                                    if (weekDay !== CODE_MASTER.SUNDAY['id'] && weekDay !== CODE_MASTER.SATURDAY['id']) {
                                        if (record.course_code === courseCode && record.fee_id === feeId) {
                                            if (holiday === 0) {
                                                cell.value = false;
                                                this.sendData = false;
                                            } else {
                                                cell.value = true;
                                            }
                                        } else if (record.course_code === courseCode && record.fee_id !== feeId && holiday !== 0) {
                                            cell.value = false;
                                        } else if (record.course_code !== courseCode && record.fee_id !== feeId) {
                                            cell.value = false;
                                        } else if (record.course_code !== courseCode && record.fee_id === feeId) {
                                        }
                                    } else {
                                        if (record.course_code === courseCode && record.fee_id === feeId) {
                                            if (holiday === 0 || holiday === 6) {
                                                cell.value = false;
                                            }
                                        }
                                    }
                                    break;
                                // 休日指定の場合
                                case 3:
                                    if (weekDay === CODE_MASTER.SUNDAY['id'] || weekDay === CODE_MASTER.SATURDAY['id'] || holiday === 0) {
                                        if (record.course_code === courseCode && record.fee_id === feeId) {
                                            cell.value = true;
                                        } else if (record.course_code === courseCode && record.fee_id !== feeId) {
                                            cell.value = false;
                                        } else if (record.course_code !== courseCode && record.fee_id !== feeId) {
                                            cell.value = false;
                                        } else if (record.course_code !== courseCode && record.fee_id === feeId) {
                                        }
                                    } else {
                                        if (record.course_code === courseCode && record.fee_id === feeId) {
                                            if (holiday !== 0 || holiday !== 6) {
                                                cell.value = false;
                                            }
                                        }
                                    }
                                    break;
                                // 期間指定の場合
                                case 4:
                                    const fromDate = new Date(`${this.search.year}-${this.search.month}-${this.input.playDateFrom}`).getTime();
                                    const toDate = new Date(`${this.search.year}-${this.search.month}-${this.input.playDateTo}`).getTime();
                                    const currentDate = new Date(current).getTime();
                                    if (fromDate <= currentDate && currentDate <= toDate) {
                                        if (record.course_code === courseCode && record.fee_id === feeId) {
                                            cell.value = true;
                                        } else if (record.course_code === courseCode && record.fee_id !== feeId) {
                                            cell.value = false;
                                        } else if (record.course_code !== courseCode && record.fee_id !== feeId) {
                                            cell.value = false;
                                        }
                                    }
                                    break;
                                }
                            }
                        }
                    });
                });
                this.sendData = false;
            }
        },
        /** --------------------------------------------
        * 更新処理
        *-------------------------------------------- */
        updateFeeIDsToPlanCells () {
            const courseCodes = this.coursesList.map(el => el.course_code);
            let updateArray = [];
            courseCodes.forEach(courseCode => {
                for (let i = 1; i <= this.targetDays; i++) {
                    let flag = 0;
                    let count = 0;
                    this.desserts.forEach((record) => {
                        Object.keys(record.days).forEach((day) => {
                            if (record.days[day]['course_code'] === courseCode) {
                                if (record.days[day]['day'] === i) {
                                    count++;
                                    if (Number(record.days[day]['value']) > 0) {
                                        const day = this.input.year + '-' + this.input.month.padStart(2, '0') + '-' + String(i).padStart(2, '0');
                                        updateArray.push({
                                            date: day,
                                            fee_id: record.fee_id,
                                            course_code: courseCode,
                                            plan_id: this.propsPlanId,
                                            golf_code: this.golfCourseProps,
                                            golf_group_code: process.env.VUE_APP_GROUP_CODE
                                        });
                                        flag = 1;
                                    }
                                    if (count === courseCodes.length && flag === 0) {
                                        const day = this.input.year + '-' + this.input.month.padStart(2, '0') + '-' + String(i).padStart(2, '0');
                                        updateArray.push({
                                            date: day,
                                            fee_id: 0,
                                            course_code: courseCode,
                                            plan_id: this.propsPlanId,
                                            golf_code: this.golfCourseProps,
                                            golf_group_code: process.env.VUE_APP_GROUP_CODE
                                        });
                                    }
                                }
                            }
                        });
                    });
                }
            });
            this.$apollo.mutate({
                mutation: UPDATE_FEE_IDS_TO_PLAN_CELLS,
                variables: {
                    dateCells: updateArray
                }
            }).then(res => {
                const result = res.data.UpdateFeeIDToPlanCell.result;
                if (result !== 0) {
                    this.process.result = result;
                    this.process.resultText = '更新完了しました';
                    this.sendData = true;
                } else if (result === 0) {
                    throw new Error('更新する情報がありませんでした。');
                }
            }).catch(error => {
                this.error = error;
                this.$set(this.process, 'result', 0);
                this.$set(this.process, 'resultText', '更新する情報がありませんでした。');
            });
        },
        /** --------------------------------------------
        * 検索ボタン処理
        * -------------------------------------------- */
        clickSearch () {
            if (!this.sendData) {
                let result = confirm('変更内容は登録されませんが、検索しますか？');
                if (result) {
                } else {
                    this.search.month = this.input.month;
                    return;
                }
            }
            this.$store.commit('loading/setIsLoading', true);
            this.loading = true;
            this.sendData = true;
            this.desserts.splice(0, this.desserts.length);
            this.makeHeaders();
            this.getCellInfo();
            this.input.year = this.search.year;
            this.input.month = this.search.month;
            this.loading = false;
            this.$store.commit('loading/setIsLoading', false);
        },
        /** --------------------------------------------
        * フォーマットされた日付を作成する 例:2020-08-01
        * -------------------------------------------- */
        formatedDate (date) {
            return this.search.year + '-' +
                   this.search.month.padStart(2, '0') + '-' +
                   String(date).padStart(2, '0');
        },
        /** --------------------------------------------
        * 「全てのチェックをクリア」ボタンの処理
        * -------------------------------------------- */
        isCheckClear () {
            this.desserts.forEach(record => {
                Object.keys(record.days).forEach(day => {
                    if (record.days[day]['value']) {
                        record.days[day]['value'] = false;
                    }
                });
            });
            this.sendData = false;
        },
        /** ----------------------------------------------
         * コースグループを取得
         * 発火タイミングはwatchで処理
         * ---------------------------------------------- */
        getCourse () {
            this.$apollo.query({
                query: GET_COURSE_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_code: this.golfCourseProps
                }
            }).then(res => {
                this.coursesList = res.data.GetCoursesList;
            });
        },
        async getFeeList () {
            this.$apollo.query({
                query: GET_FEE_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    plan_id: this.propsPlanId
                }
            }).then(res => {
                this.feeList = res.data.getFeeList.PlanFeeList;
                for (let fee of this.feeList) {
                    fee.textFee = fee.total_fee.toLocaleString();
                }
            });
        },
        /** ----------------------------------------------
         * モーダル画面を表示する処理
         * ---------------------------------------------- */
        displayAddOverLay () {
            this.addOverlay = true;
        },
        /** ----------------------------------------------
         * 追加ダイアログを閉じる
         * ---------------------------------------------- */
        closeAddOverLay (item) {
            this.process.result = '';
            this.addOverlay = false;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.sendData = true;
            this.desserts.splice(0, this.desserts.length);
            this.initialize();
            this.$refs.form.resetValidation();
            this.$emit('close');
        },
        getLinkYears () {
            return this.$apollo.mutate({
                mutation: GET_LINK_YEARS,
                variables: { golfGroupCode: process.env.VUE_APP_GROUP_CODE }
            }).then(res => {
                return res.data.GetLinkYears.YearList;
            }).catch(error => {
                this.result = 0;
                this.error = error;
            });
        },
        // 期間指定実在日チェック
        checkCorrectDate (str) {
            if (str) {
                let day = this.dateFromPre + str;
                var delim = '-';
                var arr = day.split(delim);
                if (arr.length !== 3) return false;
                if (arr[0] < 1900) return false;
                const date = new Date(arr[0], arr[1] - 1, arr[2]);
                if (arr[0] !== String(date.getFullYear()) || arr[1] !== ('0' + (date.getMonth() + 1)).slice(-2) || arr[2] !== ('0' + date.getDate()).slice(-2)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        }
    }
};
</script>

<style scoped>

    .v-data-table ::v-deep input[type=checkbox] {
        transform:  scale(1.1)
    }

    div.v-input--radio-group__input{
        flex-wrap: nowrap;
    }

    .v-radio ::v-deep label{
        word-break: keep-all;
    }

    .v-data-table ::v-deep th{
        padding: 0 10px;
    }

    .v-data-table ::v-deep td{
        padding: 0 10px;
    }

    .v-data-table ::v-deep .wordKeep{
        word-break: keep-all;
    }

    .v-data-table ::v-deep th.dayWidth0 {
        padding: 11px;
        color: #DD0000 !important;
    }

    .v-data-table ::v-deep th.dayWidth1{
        padding: 11px;
    }
    .v-data-table ::v-deep th.dayWidth2{
        padding: 11px;
    }
    .v-data-table ::v-deep th.dayWidth3{
        padding: 11px;
    }
    .v-data-table ::v-deep th.dayWidth4{
        padding: 11px;
    }
    .v-data-table ::v-deep th.dayWidth5 {
        padding: 11px;
    }

    .v-data-table ::v-deep th.dayWidth6 {
        padding: 11px;
        color: #0000CC !important;
    }
</style>
